import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="decimal-input"
export default class extends Controller {
  sanitize(event) {
    const input = event.target
    if (!input) return

    let value = input.value.toString()

    // Allow only digits and decimal separators (, or .)
    value = value.replace(/[^\d.,]/g, "")

    const separatorIndex = value.search(/[.,]/)

    if (separatorIndex >= 0) {
      const integerPart = value.slice(0, separatorIndex).replace(/[.,]/g, "")
      const separator = value[separatorIndex]
      const decimalPart = value.slice(separatorIndex + 1).replace(/[.,]/g, "")
      value = `${integerPart}${separator}${decimalPart}`
    } else {
      value = value.replace(/[.,]/g, "")
    }

    input.value = value
    input.setCustomValidity("")
  }

  validate(event) {
    const input = event.target
    if (!input) return

    const value = input.value.toString().trim()
    if (value.length === 0) {
      input.setCustomValidity("")
      return
    }

    const validDecimal = /^\d+(?:[.,]\d+)?$/
    if (!validDecimal.test(value)) {
      input.setCustomValidity("Debe ingresar solo numeros (admite coma o punto decimal)")
      input.reportValidity()
      return
    }

    input.setCustomValidity("")
  }
}
